import React, { Component } from 'react'
import PropTypes from 'prop-types'
import fullstory from '../../../../utils/constants/fullstory'

/**
 * @class OnboardingSearchBar
 * @description Generic search component that acts as a Proxy for onChange events
 */
class OnboardingSearchBar extends Component {
  /**
   * @static propTypes
   */
  static propTypes = {
    onChange: PropTypes.func.isRequired,
  }

  /**
   * @method render
   */
  render() {
    const { onChange } = this.props
    return (
      <input
        type="text"
        className={`form-control collapsed-search-box ${fullstory.classNames.searchbar}`}
        onChange={event => onChange(event.target.value)}
      />
    )
  }
}

export default OnboardingSearchBar



// WEBPACK FOOTER //
// ./src/routes/authenticated/AdminDashboard/components/OnboardingSearchBar.js